import React, { useState, useEffect } from 'react'
import BaseHome from '../Home/BaseHome'
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import Success from "../../assets/images/success-payment.png";
import Fail from "../../assets/images/fail-payment.png";
import Pending from "../../assets/images/pending-payment.png";
import Right from "../../assets/images/right-arrow.eb845750.svg";
import moment from 'moment';

const PayUStatus = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams();
    const [data, setData] = useState()
    const [date, setDate] = useState(new Date())
    const [user, setUser] = useState(null)
    const [verified, setVerified] = useState(false)

    useEffect(() => {
        // http://localhost:3000/payment-payu-status?user=GSVI2945728&status=SUCCESS&txnid=57UAFG134016GWE1OM&message=Thank%20you%20for%20purchasing%20the%20coins.&amount=10.0&paymentTimestamp
        const status = searchParams.get('status')
        const userId = searchParams.get('user')
        setUser(userId?.toString())
        const txnid = searchParams.get('txnid')
        const message = searchParams.get('message')
        const amount = searchParams.get('amount')
        const paymentTimestamp = searchParams.get('paymentTimestamp')
        let payload = {
            status,
            txnid,
            message,
            amount,
            paymentTimestamp,
        }
        console.log("payload", payload)
        setData(payload)
    }, [])

    useEffect(() => {
        if (user != null) {
            if (user != "undefined" && user != undefined && user != "error") {
                let profileLite = localStorage.getItem('profileLite')
                profileLite = JSON.parse(profileLite)
                if (profileLite && profileLite?.user_id && profileLite?.user_id.toString() === user) {
                    setVerified(true)
                }
                else {
                    // navigate('/')
                }
            }
            else {
                // navigate('/')
            }
        }
    }, [user])

    // Helper to parse "2025-07-08T19:10:53 05:30" and similar
    function parsePaymentTimestamp(ts) {
        if (!ts) return null;
        // If already ISO, just return
        if (moment(ts).isValid()) return ts;
        // Try to convert "2025-07-08T19:10:53 05:30" to "2025-07-08T19:10:53+05:30"
        const match = ts.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}) (\d{2}:\d{2})$/);
        if (match) {
            return `${match[1]}+${match[2]}`;
        }
        return ts;
    }

    return (
        <BaseHome isWallet={false} isFooter={false} title={"Payment Status"} onBackClick={() => navigate("/home")}>
            {verified &&
                data?.status == "SUCCESS" ?
                <div style={{ backgroundColor: "#2F3043", textAlign: 'center', height: "95vh", position: "relative" }} className="mt-0 payu-status d-flex justify-content-center flex-column align-items-center">
                    <div style={{position:"relative",bottom:"100px"}}>
                    <img style={{ marginTop: 42, height: 100, width: 100 }} src={Success} />
                    <div style={{ marginTop: 10 }} ><span className='status'>success</span></div>
                    {
                        <div style={{ marginTop: 0, fontSize: 30 }} >
                            <span>{data?.amount}{" ₹"}</span>
                        </div>
                    }
                    <div style={{ marginTop: 8, fontSize: 14 }} >
                        <span>
                            {
                                moment(parsePaymentTimestamp(data?.paymentTimestamp)).isValid()
                                    ? moment(parsePaymentTimestamp(data?.paymentTimestamp)).format("DD/MM/YYYY, hh:mm a")
                                    : "Invalid date"
                            }
                        </span>
                    </div>
                    {
                        <div style={{ marginTop: 16, fontSize: 14 }} >
                            <span>Transaction ID : #{data?.txnid}</span>
                        </div>
                    }
                    {
                        data?.message !== undefined && data?.message !== "undefined" &&
                        <div style={{ marginTop: 16, fontSize: 14 }} >{data?.message}</div>
                    }
                    </div>
                    <button className="mb-4 mt-4"
                        onClick={() => navigate('/home')} style={{position:"absolute",bottom:"50px"}}
                    >DONE</button>
                </div>
                : data?.status == "FAILURE" ?
                    <div style={{ backgroundColor: "#2F3043", textAlign: 'center', height: "95vh", position: 'relative' }} className="mt-0 payu-status d-flex justify-content-center flex-column align-items-center">
                        <div style={{position:"relative",bottom:"100px"}}>
                        <img style={{ marginTop: 42, height: 100, width: 100 }} src={Fail} />
                        <div style={{ marginTop: 10, fontSize: 36 }} ><span className='status'>failure</span></div>
                        {
                            <div style={{ marginTop: 0, fontSize: 30 }} ><span>{data?.amount}{" ₹"}</span></div>
                        }
                        <div style={{ marginTop: 8, fontSize: 14 }} >
                            <span>
                                {
                                    moment(parsePaymentTimestamp(data?.paymentTimestamp)).isValid()
                                        ? moment(parsePaymentTimestamp(data?.paymentTimestamp)).format("DD/MM/YYYY, hh:mm a")
                                        : "Invalid date"
                                }
                            </span>
                        </div>
                        {
                            <div style={{ marginTop: 16, fontSize: 14 }} ><span>Transaction ID : #{data?.txnid}</span></div>
                        }
                        </div>
                        <button className="mb-4 mt-4" onClick={() => navigate('/home')} style={{position:"absolute",bottom:"50px"}}>DONE</button>
                    </div>
                    :
                    <div style={{ backgroundColor: "#2F3043", textAlign: 'center', height: "95vh", position: 'relative' }} className="mt-0 payu-status d-flex justify-content-center flex-column align-items-center">
                       <div style={{position:"relative",bottom:"100px"}}>
                       <img style={{ marginTop: 42, height: 100, width: 100 }} src={Pending} />
                        <div style={{ marginTop: 10, fontSize: 36 }} ><span className='status'>pending</span></div>
                        {
                            (data?.amount !== undefined && data?.amount !== "undefined") &&
                            <div style={{ marginTop: 0, fontSize: 30 }} >
                                <span>
                                    {data?.amount}{" ₹"}</span>
                            </div>
                        }
                        {
                            data?.paymentTimestamp !== undefined && data?.paymentTimestamp !== "undefined" &&
                            <div style={{ marginTop: 8, fontSize: 14 }} >
                                <span>
                                    {
                                        moment(parsePaymentTimestamp(data?.paymentTimestamp)).isValid()
                                            ? moment(parsePaymentTimestamp(data?.paymentTimestamp)).format("DD/MM/YYYY, hh:mm a")
                                            : "Invalid date"
                                    }
                                </span>
                            </div>
                        }
                        {
                            data?.txnid !== undefined && data?.txnid !== "undefined" ?
                                <div style={{ marginTop: 16, fontSize: 14 }} ><span>Transaction ID :
                                    #{data?.txnid}</span>
                                </div>
                                : ""
                        }
                        {
                            data?.message !== undefined && data?.message !== "undefined" &&
                            <div style={{ marginTop: 16, fontSize: 14 }} ><span>{data?.message}</span></div>
                        }
                       </div>
                        <button className="mb-4 mt-4" onClick={() => navigate('/home')} style={{position:"absolute",bottom:"50px"}}>DONE</button>
                    </div>
            }
        </BaseHome>
    )
}

export default PayUStatus